import dva from 'dva';
import createLoading from 'dva-loading';
import 'moment/dist/locale/zh-cn';
import 'moment/dist/locale/ko';
import 'moment/dist/locale/zh-tw';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/ja';
import 'moment/dist/locale/en-gb';
import lodash from 'lodash';
import { reloadAuthorized } from './utils/Authorized';
import './index.less';
import { i18n, initI18n } from './i18n';
import { getConfig } from './services/server-url-config/env';
import 'antd/dist/antd.css';
import { getAppUrl } from './utils/sso';
import { initializeBurialPoint, EPlatform } from './gs-web-analytics';

// 获取IP信息并处理域名重定向
const checkAndRedirectForJapan = async () => {
  try {
    // 创建1.5秒超时Promise
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Timeout')), 1500);
    });

    // 创建获取IP信息的Promise
    const fetchPromise = fetch('https://ipinfo.io/json').then(response => response.json());

    // 使用Promise.race实现超时控制
    const ipInfo = await Promise.race([fetchPromise, timeoutPromise]);

    // 只在service.gs-robot.com域名下执行重定向逻辑
    if (window.location.hostname !== 'service.gs-robot.com') {
      return false;
    }

    // 根据国家代码确定重定向域名
    const countryRedirects = {
      'JP': 'service-ne.gs-robot.com',
      'SG': 'service-ap.gs-robot.com',
    };

    const targetDomain = countryRedirects[ipInfo.country];

    if (targetDomain) {
      // 构建重定向URL，只替换domain，其他保持不变
      const currentUrl = window.location.href;
      const newUrl = currentUrl.replace('service.gs-robot.com', targetDomain);

      // 执行重定向
      window.location.href = newUrl;
      return true; // 表示已重定向
    }
  } catch (error) {
    console.warn('Failed to fetch IP info or timeout:', error.message);
  }
  return false; // 未重定向
};

// 立即执行IP检查和重定向（在HTML加载时）
(async () => {
  const wasRedirected = await checkAndRedirectForJapan();
  if (wasRedirected) {
    return; // 如果已重定向，停止执行后续代码
  }

  // 继续应用初始化
  initializeAppAfterRedirect();
})();

const urlConfig = getConfig();

let ENV = '';
switch (urlConfig.env) {
  case 'test':
    ENV = 'local';
    break;
  case 'staging':
    ENV = 'pre';
    break;
  case 'release':
    ENV = 'daily';
    break;
  case 'prod':
    ENV = 'prod';
    break;
  default:
    ENV = '';
}

window.i18n = i18n;
window.i = i18n;
window._ = lodash;

// 确保 EPlatform 存在
console.log('Platform:', urlConfig);

if (urlConfig.region !== 'eu') {
  initializeBurialPoint(EPlatform.ROBOT_CLOUD, urlConfig?.apiUrl?.apiGatewayPrefix, urlConfig.lane || urlConfig.region || urlConfig.env);
}

const createHistory = require('history').createHashHistory;

const initializeAppAfterRedirect = () => {
  // 1. Initialize
  initI18n();

  // 2. 应用初始化
  let app;
  app = dva({
    history: createHistory(),
    onError(err) {
      console.log('error', err);
      window.location.href = getAppUrl();
    },
  });
  // 3. Plugins
  app.use(createLoading());

  // 4. Register global model
  app.model(require('./models/global').default);
  app.model(require('./models/unitSetting').default);
  // 5. Router
  app.router(require('./router').default);
  // 6. Start
  app.start('#root');

  app._store; // eslint-disable-line
  window.app = app;
  reloadAuthorized();

  window.app = app;
  window.gs = {
    LAST_BUILD_TIME: process.env.LAST_BUILD_TIME,
  };
};